<!-- @format -->

<template>
  <div class="ui">
    <div class="">
      <div class="ui attached message">
        <h3>
          Goal Risk Profile:
          {{ goalRiskProfile.getGoalRiskProfileResponse.riskProfile }}
        </h3>
      </div>
      <div class="ui attached segment">
        <div class="ui attached message">
          <strong>Recommendation </strong> <sup>1, 2</sup>
        </div>
        <div class="ui attached segment">
          <span
            v-if="
              goalRiskProfile.getGoalRiskProfileResponse.greenYellowRed == 0
            "
          >
            <strong>
              <i class="ui icon circle" style="color: green"></i>
              Proceed.</strong
            >
          </span>
          <span
            v-if="
              goalRiskProfile.getGoalRiskProfileResponse.greenYellowRed == 1
            "
          >
            <strong>
              <i class="ui icon circle" style="color: orange"></i>
              Caution.</strong
            >
            "Allocate after Discussion with Investor"
          </span>
          <span
            v-if="
              goalRiskProfile.getGoalRiskProfileResponse.greenYellowRed == 2
            "
          >
            <strong>
              <i class="ui icon circle" style="color: red"></i> Stop.</strong
            >
          </span>
          <br />
          {{ goalRiskProfile.getGoalRiskProfileResponse.message }}
          <div
            v-if="goalRiskProfile.getGoalRiskProfileResponse.greenYellowRed < 2"
          >
            <div class="ui divider"></div>
            <strong>Suitability. </strong>
            The most appropriate portfolio<span
              v-if="
                goalRiskProfile.getGoalRiskProfileResponse.suitablePortfolios
                  .length > 1
              "
              >s</span
            >
            given the investor needs & assessed goal risk profile
            <span
              v-if="
                goalRiskProfile.getGoalRiskProfileResponse.suitablePortfolios
                  .length > 1
              "
              >are</span
            ><span v-else>is</span>

            <ul>
              <li
                v-for="u in goalRiskProfile.getGoalRiskProfileResponse
                  .suitablePortfolios"
              >
                <h4>
                  <i class="ui icon check" style="color: green"></i
                  >{{ u.portfolioName }}
                  <br />
                  <small>
                    The strategic asset allocation composition of the
                    {{ u.portfolioName }} is approriate given the goal's
                    objectives and assessed risk profile. Given our long-term
                    capital market expectations, the fund has got annualised
                    volatility of
                    {{ formatNr(u.annualisedStandardDeviation, "0,0.0%") }} and
                    a long-term
                    {{ formatNr(u.expectedReturn, "0,0.0%") }} expected rate of
                    return.
                  </small>
                </h4>
              </li>
            </ul>
          </div>
        </div>
        <div class="ui attached message" style="font-size: 0.9em">
          Recommendation as per Hubble–Grable Three-Factor Model of Investor
          Risk Profiling<br />
          <br />

          <i>Sources:</i> <br />
          <sup>1</sup> CFA, Investment Risk Profiling: A guide for financial
          advisors. 2020 <br /><sup>2</sup>
          A. Hubble, “The Amalgamation of Professional Judgement: A Mean–Variant
          Approach from an International Survey of Financial Advisers” (PhD
          diss., University of Georgia, 2018).
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";
import vSelect from "vue-select";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import "vue-select/dist/vue-select.css";
import { getRiskProfiles, getGoalRiskProfile } from "@/gateway.js";

export default {
  name: "GoalTypes",
  components: { vSelect, VueSlider },
  props: ["currency", "goalRiskProfile", "activePlan"],
  data() {
    return {
      getGoalRiskProfileResponse: null,
    };
  },
  computed: {},
  watch: {
    /*goalRiskProfile: {
      handler: function(newValue) {
        console.log(
          "something changed on the risk profile side:" + newValue + " modified"
        );
      },
      deep: true
    }*/
  },
  methods: {
    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else return numeral(val).format("0,0");
    },
    async calculateGoalRiskProfile() {
      if (this.goalRiskProfile) {
        const response = await getGoalRiskProfile({
          currency: this.currency,
          getRiskToleranceResponse: this.goalRiskProfile
            .getRiskToleranceResponse,
          getRiskAbilityResponse: this.goalRiskProfile.getRiskAbilityResponse,
          getRiskNeedResponse: this.goalRiskProfile.getRiskNeedResponse,
        });
        if (response) {
          this.goalRiskProfile.getGoalRiskProfileResponse = response;
          this.activePlan.goalRiskProfile = this.goalRiskProfile;
          this.getGoalRiskProfileResponse = response;
        }
      }
    },
    async handleRiskChanged() {
      //await this.calculateGoalRiskProfile();
    },
    async init() {
      var response = await getRiskProfiles();
      if (response) {
        this.riskProfiles = response.result;

        // await this.calculateGoalRiskProfile();
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
